export const locale = {
    lang: "es",
    data: {
        BILLS: {
            MYBILLS: "Facturas",
        },
    },
};
